// removed by extract-text-webpack-plugin
module.exports = {"InfoBox":"Info_InfoBox__Tchu","InfoIcon":"Info_InfoIcon__y78I","ShowInfo":"Info_ShowInfo__WVRm","CloseBox":"Info_CloseBox__3PZw","CloseIcon":"Info_CloseIcon__2aEk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Map/Info/Info.scss
// module id = 528
// module chunks = 0